import React from 'react';

function InstagramProfileHeader({ postCount = 0 }) {
  return (
    <>
      <div className="profile-container-mobile w-full max-w-md mx-auto text-center font-sans px-4 py-4">
        <img
          src="/the-dorcol-profile.jpg"
          alt="The Dorcol Residence Logo"
          className="profile-image-mobile mx-auto mb-3 mt-2 rounded-full object-cover border border-gray-300"
          style={{ width: 96, height: 96 }}
        />

        {/* Corrected: @username placed here */}
        <div className="username-mobile font-semibold text-sm mb-2">@thedorcolresidence</div>

        <div className="stats-row-mobile flex justify-center gap-6 mb-3">
          <div className="stat-mobile text-center">
            <div className="stat-number-mobile font-semibold text-base">{postCount}</div>
            <div className="stat-label-mobile text-xs text-gray-600">Posts</div>
          </div>
          <div className="stat-mobile text-center">
            <div className="stat-number-mobile font-semibold text-base">1,358</div>
            <div className="stat-label-mobile text-xs text-gray-600">Followers</div>
          </div>
          <div className="stat-mobile text-center">
            <div className="stat-number-mobile font-semibold text-base">29</div>
            <div className="stat-label-mobile text-xs text-gray-600">Following</div>
          </div>
        </div>

        <div className="bio-mobile mb-2">
          <div className="text-[13px] leading-snug">The Dorcol Residence</div>
          <div className="text-[13px] leading-snug">Kontakt +381 11 66 66 611</div>
          <div className="text-[13px] leading-snug">info@thedorcolresidence.com</div>
          <div className="text-[13px] leading-snug">The Dorcol Residence, Belgrade, Serbia</div>
        </div>

        <a
          className="website-link-mobile block mt-3 text-[#00376b] font-medium text-base no-underline"
          href="https://thedorcolresidence.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          thedorcolresidence.com
        </a>
      </div>

      <hr className="border-t border-gray-300 opacity-90" />

      <style>{`
        @media (max-width: 768px) {
          .profile-container-mobile {
            padding-bottom: 20px;
          }

          .profile-image-mobile {
            margin-bottom: 12px !important;
          }

          .username-mobile {
            font-weight: 600;
            font-size: 14px;
            margin-bottom: 12px;
          }

          .stats-row-mobile {
            gap: 24px !important;
            margin-bottom: 12px !important;
          }

          .stat-number-mobile {
            font-weight: 600;
            font-size: 16px;
          }

          .stat-label-mobile {
            font-size: 12px;
            color: #666;
          }

          .bio-mobile div {
            font-size: 13px;
            line-height: 1.4;
            margin-bottom: 2px;
          }

          .website-link-mobile {
            margin-top: 12px;
            color: #00376b;
            font-weight: 500;
            text-decoration: none;
          }
        }
      `}</style>
    </>
  );
}

export default InstagramProfileHeader;
